import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField"; // Demo Requirement changes for Wockhardt + CQA flow.
import { useStyles } from "../updateBatchStyles";
import InputNumber from "../../../../models/inputs/InputNumber";
import CustomDatePickerMui from "../../../../models/inputs/DateInput";
import CloseIcon from "@material-ui/icons/Close";
import { presentDate } from "../../../../functionalComponents/dataFormatFunctions";
import {
  Box,
  Button,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import MandatorySpan from "../../../models/MandatorySpan";
import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import StyledButton from "../../../../../../../common/models/Button";

const ShippingInformation = (props) => {
  const classes = useStyles();
  const {
    batchDetails,
    errors,
    handleDateChange,
    handleChange,
    quickView,
    handleChangeShipmentIdAndName,
    currentStatusId, handleOpenReceived,
    onSubmit,
    disableSaveButton,
  } = props;
  // console.log("batchDetails", batchDetails);
  const moment = require("moment");

  // Demo Requirement changes for Wockhardt + CQA flow.
  const handleShipmentIdChange = (event) => {
    const value = event.target.value;
    if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 12) {
      handleChangeShipmentIdAndName(event);
    }
  };

  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  // const formattedDate = moment().format("DD-MMM-YYYY");

  return (
    <>
      <React.Fragment>
        <Grid container className={classes.grid}>
          <Grid item xs={12} sm={12} md={12} className={classes.containingObjects}>
            <Grid style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h4" className={classes.title} >
                Shipping Information
              </Typography>
              <span className={classes.borders}></span>
            </Grid>
            {localStorage.collabType !== 'CMO' && !quickView &&
              (batchDetails.SASLBatchStatusID === 9 ||
                batchDetails.SASLBatchStatusID === 7 ||
                batchDetails.SASLBatchStatusID === 18 ||
                batchDetails.SASLBatchStatusID === 19) && (
                <StyledButton
                  onClick={
                    batchDetails.SASLBatchStatusID === 9
                      ? handleOpenReceived
                      : onSubmit
                  }
                  disabled={disableSaveButton}
                >
                  {batchDetails.SASLBatchStatusID === 9
                    ? "Mark as received and generate GRN"
                    : "Save changes"}
                </StyledButton>
              )}
          </Grid>

          {/* // Demo Requirement changes for Wockhardt + CQA flow. */}
          {/* Dispatch Quantity */}
          <Grid item xs={12} sm={5} md={4} lg={3} className={classes.grid}>
            <Typography variant="body2" className={classes.filesFont}>
              {"Dispatch Quantity "}
              {!quickView && localStorage.collabType === "CMO" && (
                <MandatorySpan />
              )}
            </Typography>
            {!quickView && localStorage.collabType === "CMO" ? (
              <InputNumber
                className={classes.fontPadding2}
                name="dispatchQuantity"
                inputProps={{ min: 0, step: 1 }}
                value={batchDetails.dispatchQuantity}
                onChange={handleChange}
                placeholder="Enter Dispatch Quantity"
                disabled={localStorage.collabType !== "CMO" ? true : false}
                helperText={errors.dispatchQuantity}
                notFullWidth
              />
            ) : (
              <Typography variant="body2" className={classes.fontPadding}>
                {batchDetails.dispatchQuantity
                  ? batchDetails.dispatchQuantity
                  : " NA "}
              </Typography>
            )}
          </Grid>

          {/* Dispatch Quantity */}
          <Grid item xs={12} sm={5} md={4} lg={3} className={classes.grid}>
            <Typography variant="body2" className={classes.filesFont}>
              {"Dispatch Quantity UOM "}
            </Typography>
            <Typography variant="body2" className={classes.fontPadding}>
              {batchDetails?.targetQuantityUOM
                ? batchDetails.targetQuantityUOM
                : "NA"}
            </Typography>
          </Grid>

          {/* Dispatch Quantity */}
          {/* <Grid item xs={12} sm={5} md={4} lg={4} className={classes.grid}>
            <Typography variant="body2" className={classes.filesFont}>
              {"PO Quantity UOM "}
            </Typography>
            <Typography variant="body2" className={classes.fontPadding}>
              {batchDetails.batchUOM ? batchDetails.batchUOM : "NA"}
            </Typography>
          </Grid> */}

          {/* Dispatch Date */}
          <Grid item xs={12} sm={5} md={4} lg={3} className={classes.grid}>
            <Typography variant="body2" className={classes.filesFont}>
              {"Dispatch Date "}
              {!quickView && localStorage.collabType === "CMO" && (
                <MandatorySpan />
              )}
            </Typography>
            {!quickView && localStorage.collabType === "CMO" ? (
              <CustomDatePickerMui
                name="dispatchDate"
                minDate={
                  batchDetails.batchEndDate !== null
                    ? batchDetails.batchEndDate
                    : new Date()
                }
                value={batchDetails.dispatchDate}
                onChange={(date) => handleDateChange(date, "dispatchDate")}
                helperText={errors.dispatchDate}
                disabled={localStorage.collabType !== "CMO" ? true : false}
                notFullWidth
              />
            ) : (
              <Typography variant="body2" className={classes.fontPadding}>
                {/* {presentDate(batchDetails.dispatchDate)} */}
                {batchDetails.dispatchDate
                  ? moment(batchDetails?.dispatchDate).format("DD-MMM-YYYY").toUpperCase()
                  : "NA"}
              </Typography>
            )}
          </Grid>

          {/* Shipper Name */}
          <Grid item xs={12} sm={5} md={4} lg={3} className={classes.grid}>
            <Typography variant="body2" className={classes.filesFont}>
              {"Shipper Name "}
              {!quickView && localStorage.collabType === "CMO" && (
                <MandatorySpan />
              )}
            </Typography>
            {!quickView && localStorage.collabType === "CMO" ? (
              <TextField
                className={classes.shipmentTextBox}
                name="shipperName"
                variant="outlined"
                value={batchDetails.shipperName}
                onChange={handleChangeShipmentIdAndName}  
                onBlur={(e) => {
                  const { value } = e.target;
                  // Trim leading and trailing spaces for string values
                  if (typeof value === "string" && value.trim() !== value) {
                    handleChangeShipmentIdAndName({ target: { name: "shipperName", value: value.trim() } });
                  }
                }}
                placeholder="Enter Shipper Name"
                error={!!errors.shipperName}
                helperText={errors.shipperName}
              />
            ) : (
              <Typography variant="body2" className={classes.fontPadding}>
                {batchDetails?.shipperName ? batchDetails.shipperName : "NA"}
              </Typography>
            )}
          </Grid>

          {/* Shipment ID */}
          <Grid item xs={12} sm={5} md={4} lg={3} className={classes.grid}>
            <Typography variant="body2" className={classes.filesFont}>
              {"Shipment ID "}
              {!quickView && localStorage.collabType === "CMO" && (
                <MandatorySpan />
              )}
            </Typography>
            {!quickView && localStorage.collabType === "CMO" ? (
              <TextField
                className={classes.shipmentTextBox}
                name="shipmentID"
                variant="outlined"
                value={batchDetails.shipmentID}
                onChange={handleShipmentIdChange} 
                onBlur={(e) => {
                  const { value } = e.target;
                  // Trim leading and trailing spaces for string values
                  if (typeof value === "string" && value.trim() !== value) {
                    handleShipmentIdChange({ target: { name: "shipmentID", value: value.trim() } });
                  }
                }}
                placeholder="Enter Shipment ID"
                error={!!errors.shipmentID}
                helperText={errors.shipmentID}
                inputProps={{
                  maxLength: 12,
                }}
              />
            ) : (
              <Typography variant="body2" className={classes.fontPadding}>
                {batchDetails?.shipmentID ? batchDetails.shipmentID : "NA"}
              </Typography>
            )}
          </Grid>

          {/* // Demo Requirement changes for Wockhardt + CQA flow.  */}


          {/* Dispatch Date */}
          <Grid item xs={12} sm={5} md={4} lg={3} className={classes.grid}>
            <Typography variant="body2" className={classes.filesFont}>
              {currentStatusId === 9 ? "Actual Delivery Date" : "Expected Delivery Date "}
              {!quickView && localStorage.collabType === "CMO" && (
                <MandatorySpan />
              )}
            </Typography>
            {!quickView && localStorage.collabType === "CMO" ? (
              <CustomDatePickerMui
                name="expectedDeliveryDate"
                minDate={
                  batchDetails.dispatchDate !== null
                    ? batchDetails.dispatchDate
                    : new Date()
                }
                value={
                  batchDetails?.expectedDeliveryDate
                    ? batchDetails?.expectedDeliveryDate
                    : null
                }
                onChange={(date) =>
                  handleDateChange(date, "expectedDeliveryDate")
                }
                helperText={errors.expectedDeliveryDate}
                disabled={localStorage.collabType !== "CMO" ? true : false}
                notFullWidth
              />
            ) : (
              <Typography variant="body2" className={classes.fontPadding}>
                {currentStatusId === 9
                  ? batchDetails?.actualDeliveryDate
                    ? moment(batchDetails.actualDeliveryDate).format("DD-MMM-YYYY").toUpperCase()
                    : "NA"
                  : batchDetails?.expectedDeliveryDate
                    ? moment(batchDetails?.expectedDeliveryDate).format("DD-MMM-YYYY").toUpperCase()
                    : "NA"}
              </Typography>
            )}
          </Grid>

          {/* Dispatch Quantity */}
          <Grid item xs={12} sm={5} md={4} lg={4} className={classes.grid} style={{ display: 'flex', }}>
            <Grid >
              <Typography variant="body2" className={classes.filesFont}>
                {"ASN Number"}
              </Typography>
              <Typography variant="body2" className={classes.fontPadding}>
                {batchDetails.asnNumber ? batchDetails.asnNumber : "NA"}
              </Typography>
            </Grid>
            <Grid >
              <Button
                className={classes.viewASNBtn}
                variant="contained"
                //startIcon={<ViewASNDetails />} // Remove unused icon
                style={{ borderRadius: "20px", marginTop: '15px', marginLeft: '22px' }}
                onClick={handleOpenDialog} // Open the Dialog on button click
                disabled={batchDetails?.asnNumber ? false : true}
              >
                View ASN details
              </Button>
            </Grid>

          </Grid>

          {/* <Grid item xs={12} sm={5} md={4} lg={3} className={classes.grid}>
            <Button
              className={classes.viewASNBtn}
              variant="contained"
              //startIcon={<ViewASNDetails />} // Remove unused icon
              style={{ borderRadius: "20px" }}
              onClick={handleOpenDialog} // Open the Dialog on button click
              disabled={batchDetails?.asnNumber ? false : true}
            >
              View ASN details
            </Button>
          </Grid> */}
        </Grid>

        <hr />
      </React.Fragment>
      {/* <ViewASNDetails
      open={openDialog}
      onClose={handleCloseDialog}
      
    /> */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          mb={2}
        >
          <Grid item xs={2} sm={2} md={2}>
            <Typography
              variant="body2"
              style={{
                display: "flex",
                alignItems: "center",
                position: "absolute",
                top: "12px",
                right: "10px",
                cursor: "pointer",
                fontWeight: 600
              }}
              onClick={handleCloseDialog}
            >
              Cancel{" "}
              <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
            </Typography>
          </Grid>
        </Box>
        <DialogTitle
          variant="h2"
          style={{
            textAlign: "center",
            // flexGrow: 1,
            // fontSize: "2.5rem",
            // fontWeight: "bold",
            // color: "black",
          }}
        >
          <Typography
            variant="body2"
            style={{
              fontSize: "2rem",
              display: "inline",
              fontWeight: 550,
              marginBottom: "1rem",
              color: "black",
            }}
          >
            View ASN Details
          </Typography>
          {/* View ASN Details */}
        </DialogTitle>
        <DialogContent>
          {/* Render ViewASNDetails component */}
          <TableContainer
            component={Paper}
            style={{ backgroundColor: "#f2f8fb" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>BMS</TableCell>
                  <TableCell>CMO</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Plant ID
                  </TableCell>
                  <TableCell>PO - Line</TableCell>
                  <TableCell>Product Code/Description</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    Batch Number
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{batchDetails?.sponsorOrgName || "NA"}</TableCell>
                  <TableCell>{batchDetails?.cmoMember || "NA"}</TableCell>
                  <TableCell>{batchDetails?.vendorPlant || "NA"}</TableCell>
                  <TableCell
                    style={{ whiteSpace: "nowrap" }}
                  >{`${batchDetails?.scheduleAgreementNumber} - ${batchDetails?.scheduleLineItemNumber}`}</TableCell>
                  <TableCell>{`${batchDetails?.fgMaterialCode} / ${batchDetails?.fgMaterialName}`}</TableCell>
                  <TableCell>{batchDetails?.vendorBatchNumber || "NA"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box mt={3}>
            <TableContainer
              component={Paper}
              style={{ backgroundColor: "#f2f8fb" }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Pickup Address</TableCell>
                    <TableCell>Delivery Address</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{batchDetails?.pickup_address || "NA"}</TableCell>
                    <TableCell>{batchDetails?.delivery_address || "NA"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          {/* <Grid item xs={12} sm={12} md={12}>
              <Typography
                variant='h6'
                style={{
                  border: '1px solid #FF0000',
                  backgroundColor: '#FFF0F0',
                  opacity: '1',
                  textAlign: 'center',
                  padding: '0.8rem',
                  fontSize: '0.875rem',
                }}
              >
              </Typography>
              </Grid> */}

          <Grid container spacing={3}>
            <Grid item xs={11}>
              <hr
                style={{
                  border: "2.3px solid #B0B0B0",
                  marginTop: "2rem",
                  marginBottom: "0.5rem",
                  width: "55rem",
                  borderBottom: "thick",
                }}
              />
            </Grid>
          </Grid>

          <Box mt={3}>
            <Grid item xs={12}>
              <Typography
                variant="body2"
                style={{
                  fontSize: "1.5rem",
                  display: "inline",
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                }}
              >
                Shipping Information
              </Typography>
              <hr
                style={{
                  backgroundColor: "grey",
                  width: "2.5rem",
                  height: "3px",
                  margin: "inherit",
                  marginBottom: "1rem",
                  marginTop: "0.25rem",
                }}
              />
            </Grid>

            <TableContainer elevation={3} style={{ border: "none" }}>
              <Table style={{ border: "none" }}>
                <TableBody style={{ border: "none", borderBottom: "none" }}>
                  {/* Row 1 */}
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Dispatch Quantity
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Dispatch Quantity UoM
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}></TableCell>
                </TableBody>
                <TableRow style={{ border: "none" }}>
                  <TableCell style={{ borderBottom: "none" }}>
                    {batchDetails?.dispatchQuantity || "NA"}
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    {batchDetails?.targetQuantityUOM || "NA"}
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}></TableCell>
                </TableRow>
                {/* Row 2 */}
                <TableBody style={{ border: "none" }}>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      {" "}
                      Dispatch Date{" "}
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Shipper Name
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      Shipment ID
                    </Typography>
                  </TableCell>
                </TableBody>
                <TableRow style={{ border: "none" }}>
                  <TableCell style={{ borderBottom: "none" }}>
                    {batchDetails.dispatchDate
                      ? moment(batchDetails?.dispatchDate).format("DD-MMM-YYYY").toUpperCase()
                      : "NA"}
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    {batchDetails?.shipperName || "NA"}
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    {batchDetails?.shipmentID || "NA"}
                  </TableCell>
                </TableRow>
                {/* Row 3 */}
                <TableBody style={{ border: "none" }}>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      {currentStatusId === 9 ? "Actual Delivery Date" : "Expected Delivery Date"}
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", color: "black" }}
                    >
                      ASN Number
                    </Typography>
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}></TableCell>
                </TableBody>
                <TableRow style={{ border: "none" }}>
                  <TableCell style={{ borderBottom: "none" }}>
                    {currentStatusId === 9
                      ? batchDetails?.actualDeliveryDate
                        ? moment(batchDetails?.actualDeliveryDate).format(
                          "DD-MMM-YYYY"
                        ).toUpperCase()
                        : 'NA'
                      : batchDetails?.expectedDeliveryDate
                        ? moment(batchDetails?.expectedDeliveryDate).format(
                          "DD-MMM-YYYY"
                        ).toUpperCase()
                        : "NA"}
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}>
                    {batchDetails?.asnNumber || "NA"}
                  </TableCell>
                  <TableCell style={{ borderBottom: "none" }}></TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ShippingInformation;
